

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

// interface ingredients {
//     heading?: string;
//     subheading?: string;
//     para?: string;
//     items: ListItem[];
// }

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}
interface injectionList {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    injectionList: injectionList;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const weightlossIV: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "weight-loss-iv-drip",
        "meta": {
            "title": "Weight Loss IV Drip in Dubai | Elite Body Home",
            "description": "Specialized IV therapy to accelerate weight loss while boosting energy and metabolism with essential nutrients delivered directly to your bloodstream.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/weight-loss-iv-drip/",
            "og": {
                "title": "Weight Loss IV Drip in Dubai | Elite Body Home",
                "description": "IV therapy for effective weight loss, energy boost and metabolic support",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-51.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Weight Loss IV Drip"],
        "hero": {
            "title": "Weight Loss IV Drip in Dubai",
            "subtitle": "Metabolic Enhancement Therapy",
            "description": "We specialize in helping you lose weight while providing you energy and metabolic assistance through our Weight Loss IV Drip at Elite Body Home. Our medical professionals blend sophisticated medical treatments with customized treatment modalities to deliver effective, safe and fast-acting results. Rich in essential nutrients and fat-burning properties, this IV drip speeds up weight loss and boosts your body's natural processes, so you feel refreshed and invigorated."
        },
        "injectionList": {
            "heading": "We offer various types of weight loss injections",
            "subheading": "Tailored to individual needs and goals",
            "items": [
                {
                    "title": "Fat Burning Injections",
                    "desc": "Targeted at areas where fat is stubborn like the abdomen, thighs and arms. The injections boost metabolism and aid in the breakdown of fat cells which are subsequently expelled from the body naturally.",
                    icon: "fa-solid fa-fire",
                },
                {
                    "title": "Aqualyx Fat Dissolving",
                    "desc": "A non-invasive fat reduction procedure that helps to dissolve fat in unwanted places, be it the chin, thighs, belly or abdomen. This facial injection uses deoxycholic acid to destroy fat cells, resulting in a more sculpted look.",
                    icon: "fa-solid fa-droplet",
                },
                {
                    "title": "Weight Loss Injections",
                    "desc": "An effective solution for those looking to lose weight quickly. These revolutionary treatments increase your metabolism, decrease appetite, and enhance fat loss–all of which helps facilitate the natural functions of your body.",
                    icon: "fa-solid fa-syringe",
                },
                {
                    "title": "Mounjaro Injection",
                    "desc": "A state-of-art weight loss injection used to regulate blood sugar levels & facilitate weight loss by controlling hunger & enhancing metabolic processes. It is recommended for people with obesity or those with difficulty losing weight.",
                    icon: "fa-solid fa-dna",
                },
                {
                    "title": "Ozempic Injection",
                    "desc": "A once-weekly injectable prescription medication that is used to control blood sugar levels in adults with type 2 diabetes. It also assists in management of weight by suppressing appetites and aiding in healthy metabolism.",
                    icon: "fa-solid fa-prescription-bottle-medical",
                },
                {
                    "title": "Weight Loss IV",
                    "desc": "A specialized IV Drip with a combination of vitamins, minerals and amino acids to enhance metabolism and energize. This approach helps the body better burn fat while addressing the right nutrients necessary to maintain general well being during a weight-loss program.",
                    icon: "fa-solid fa-vial",
                }
            ]
        },
        "howItWorks": {
            "title": "How Does Weight Loss IV Drip Work?",
            "description": "Weight Loss IV Drip therapy is the delivery of a mixture of essential vitamins, minerals and fat-burning materials directly into your bloodstream. Unlike oral supplements that require digestion, intravenous administration allows for faster and more efficient bioavailability of nutrients."
        },
        "procedureSteps": {
            "heading": "Procedure Overview",
            "para": "Our Weight Loss IV Drip delivers key ingredients directly to your system:",
            "steps": [
                {
                    "title": "Direct Nutrient Delivery",
                    "desc": "The IV drip skips the digestive tract altogether, providing nutrients in an entirely absorbable form, 100%.",
                    "icon": "fa-solid fa-vial"
                },
                {
                    "title": "Key Ingredients",
                    "desc": "Contains amino acids (like carnitine), lipotropic agents (methionine, inositol, choline), B-complex vitamins, and other micronutrients.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "Fat Metabolism",
                    "desc": "These components work together to enhance your metabolism and help your body burn fat more efficiently.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "Energy Boost",
                    "desc": "The therapy increases energy levels, allowing you to remain more active throughout the day.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Quick Session",
                    "desc": "The treatment takes 30-45 minutes in a relaxing environment with no downtime.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Weight Loss IV Drip",
            "subheading": "Comprehensive support for your weight loss journey",
            "para": "The Weight Loss IV Drip has various benefits that can supplement your weight loss plan:",
            "items": [
                {
                    "title": "Accelerated Fat Burning",
                    "desc": "Aids in the metabolism of fat and the breakdown of fat deposits in the liver.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "Boosts Metabolism",
                    "desc": "Nutrients like carnitine boost your body's potential to burn fat, speeding up weight loss.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Improved Energy",
                    "desc": "Vitamin B12 acts against fatigue, making it easier to remain motivated and active.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "Enhanced Hydration",
                    "desc": "Supports digestion, improves nutrient absorption, and keeps the body running properly.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Detoxification",
                    "desc": "Contains antioxidants to flush out toxins and enhance liver function for better fat breakdown.",
                    "icon": "fa-solid fa-recycle"
                },
                {
                    "title": "Minimal Side Effects",
                    "desc": "As the ingredients naturally occur in the body, side effects are rare and minimal.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit from Weight Loss IV Drip?",
            "subheading": "",
            "para": "Weight Loss IV Drip helps those who need extra support in their weight loss journey:",
            "items": [
                {
                    "title": "Those Dealing with Stubborn Fat",
                    "desc": "If you're already dieting and exercising but not achieving desired results, this treatment could help.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "People with Slow Metabolism",
                    "desc": "The metabolism-boosting ingredients can help jump-start the process of burning excess fat.",
                    "icon": "fa-solid fa-tachometer-alt"
                },
                {
                    "title": "Busy Professionals",
                    "desc": "People with busy schedules who struggle to maintain energy levels for exercise.",
                    "icon": "fa-solid fa-briefcase"
                },
                {
                    "title": "Health-Conscious Individuals",
                    "desc": "Those looking for a natural, safe way to enhance their weight loss efforts.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Your Treatment",
            "subheading": "",
            "para": "Preparing for your Weight Loss IV Drip session:",
            "items": [
                {
                    "title": "Consultation",
                    "desc": "Discuss your weight loss goals, medical history, and current health status with our healthcare provider.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Lab Tests",
                    "desc": "Sometimes lab work might be ordered to check for any nutrient deficiencies.",
                    "icon": "fa-solid fa-microscope"
                },
                {
                    "title": "Hydration",
                    "desc": "Drink plenty of water before your session to prepare your body.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Avoid Heavy Meals",
                    "desc": "Don't eat a large meal beforehand to avoid discomfort during the procedure.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Relax",
                    "desc": "The session lasts 30-45 minutes in a comfortable relaxing area.",
                    "icon": "fa-solid fa-couch"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "Most patients experience some combination of the following results:",
            "items": [
                {
                    "title": "Increased Energy",
                    "desc": "Most people experience an energy boost from day one, helping burn more calories.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Accelerated Fat Loss",
                    "desc": "Over time, the drip improves your body's fat-burning potential for effective weight reduction.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Improved Mood & Mental Clarity",
                    "desc": "Vitamins and nutrients facilitate brain function, improving focus and reducing stress.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "Enhanced Hydration & Health",
                    "desc": "Better hydration leads to improved digestion, glowing skin, and efficient body functions.",
                    "icon": "fa-solid fa-tint"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maximize and maintain your results:",
            "items": [
                {
                    "title": "Maintain Hydration",
                    "desc": "Continue drinking plenty of water to support your metabolism.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Healthy Diet",
                    "desc": "Follow a balanced diet to complement the treatment effects.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Regular Exercise",
                    "desc": "Stay active to enhance fat burning and maintain results.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Follow-up Sessions",
                    "desc": "Consider regular treatments for sustained weight loss benefits.",
                    "icon": "fa-solid fa-calendar-alt"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long does a Weight Loss IV Drip session take?",
                    "answer": "The session typically takes 30-45 minutes in a relaxing environment."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "You may feel a small pinch during needle insertion, but the treatment itself is painless."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "Many patients notice increased energy immediately, with fat loss results becoming visible over several sessions."
                },
                {
                    "question": "How often should I get this treatment?",
                    "answer": "Frequency depends on individual goals - our medical team can recommend a schedule during consultation."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Side effects are rare but may include minor bruising at the injection site. The ingredients are naturally occurring in the body."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Bagfyhnner-Image-8-scaled.jpg",
            "beforeAfter": [
                {
                    image:
                        "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/105.webp",
                    alt: "Ozempic Injection in Dubai",
                },
                {
                    image:
                        "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/110.webp",
                    alt: "Belly Fat Removal",
                },
                {
                    image:
                        "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Postnatal-Weight-Loss-3.webp",
                    alt: "Postnatal Weight Loss",
                },
            ]
        },
        "product": {
            "id": 7,
            "title": "Weight Loss IV Drip in Dubai",
            "description": "Specialized IV therapy to accelerate weight loss while boosting energy and metabolism with direct nutrient infusion.",
            "price": 599
        }
    },
    "ar": {
        "url": "weight-loss-iv-drip",
        "meta": {
            "title": "التنقيط الوريدي لخسارة الوزن في دبي | ايليت بودي هوم",
            "description": "علاج متخصص لتعزيز خسارة الوزن وزيادة الطاقة وتحسين التمثيل الغذائي من خلال تركيبة مغذية تعطى مباشرة في الوريد.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/weight-loss-iv-drip",
            "og": {
                "title": "التنقيط الوريدي لخسارة الوزن في دبي | ايليت بودي هوم",
                "description": "علاج وريدي لخسارة الوزن الفعالة مع تعزيز الطاقة والتمثيل الغذائي",
                "image": "https://www.elitebodyhome.com/images/weight-loss-iv-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "التنقيط الوريدي لخسارة الوزن"],
        "hero": {
            "title": "التنقيط الوريدي لخسارة الوزن في دبي",
            "subtitle": "علاج تعزيز التمثيل الغذائي وحرق الدهون",
            "description": "توفر لك عيادات ايليت بودي هوم الدعم الكامل لخسارة الوزن من خلال جلسات التنقيط الوريدية المصممة خصيصًا لهذا الهدف، والتي تعزز مستويات الطاقة وتحسين التمثيل الغذائي بكفاءة. يُعد علاج التنقيط الوريدي لخسارة الوزن مزيجًا غنيًا بالعناصر الغذائية الأساسية والمكونات التي تساعد على تعزيز حرق الدهون، مما يسرع عملية خسارة الوزن الطبيعية بشكل آمن وفعال ويمنح جسمك دفعة من النشاط والحيوية."
        },
        "injectionList": {
            "heading": "نقدم مجموعة متنوعة من إبر إنقاص الوزن",
            "subheading": "مصممة خصيصًا لتلائم احتياجاتك وأهدافك الفردية",
            "items": [
                {
                    "title": "إبر حرق الدهون",
                    "desc": "تُركز هذه الإبر على المناطق التي يصعب التخلص من الدهون المتراكمة بها مثل الأرداف والذراعين، حيث تُعزز من معدل الأيض وتساعد على تكسير الخلايا الدهنية.",
                    icon: "fa-solid fa-fire",
                },
                {
                    "title": "إبر أكواليكس لإذابة الدهون",
                    "desc": "تُعد إبر إذابة الدهون من أحدث طرق العلاج غير الجراحية لتقليل الدهون الموضعية، حيث تستهدف الدهون العنيدة في مناطق مثل الذقن، أو الفخذين، أو البطن.",
                    icon: "fa-solid fa-droplet",
                },
                {
                    "title": "إبر إنقاص الوزن",
                    "desc": "تُعد من الحلول الحديثة والفعالة لمن يرغب في التخلص من الوزن الزائد سريعًا، حيث تعمل هذه الإبر على تعزيز معدل الأيض، وكبح الشهية، وتحفيز حرق الدهون.",
                    icon: "fa-solid fa-syringe",
                },
                {
                    "title": "إبرة مونجارو",
                    "desc": "يُعد مونجارو من الإبر المتطورة المستخدمة في دبي للمساعدة على فقدان الوزن وتنظيم مستويات السكر في الدم. يساهم في السيطرة على الشهية وتحفيز عمليات التمثيل الغذائي.",
                    icon: "fa-solid fa-dna",
                },
                {
                    "title": "إبرة أوزمبيك",
                    "desc": "أوزمبيك هو دواء يُحقن مرة أسبوعيًا، يُستخدم بشكل أساسي لضبط مستويات السكر في الدم لدى البالغين المصابين بالسكري من النوع الثاني. كما يُساعد على التحكم في الشهية وتحسين عملية التمثيل الغذائي.",
                    icon: "fa-solid fa-prescription-bottle-medical",
                },
                {
                    "title": "العلاج الوريدي لإنقاص الوزن",
                    "desc": "علاج التنقيط الوريدي المتخصص لإنقاص الوزن، يحتوي على مزيج فعّال من الفيتامينات والمعادن والأحماض الأمينية لتحفيز الأيض وتعزيز مستويات الطاقة.",
                    icon: "fa-solid fa-vial",
                }
            ]
        },
        "howItWorks": {
            "title": "كيف يعمل العلاج الوريدي لإنقاص الوزن؟",
            "description": "تُعد جلسة العلاج الوريدي لإنقاص الوزن وسيلة فعالة لإيصال مزيج من الفيتامينات والمعادن والمكونات المحفزة لحرق الدهون مباشرةً إلى مجرى الدم، مما يضمن امتصاصًا سريعًا وكفاءة عالية مقارنةً بالمكملات الغذائية التي تؤخذ عن طريق الفم."
        },
        "procedureSteps": {
            "heading": "خطوات الإجراء",
            "para": "يقدم علاج التنقيط الوريدي مكونات أساسية مباشرة إلى جسمك:",
            "steps": [
                {
                    "title": "توفير سريع للعناصر الغذائية",
                    "desc": "تتجاوز هذه التقنية الجهاز الهضمي بالكامل، ما يتيح امتصاص المكونات بنسبة 100%.",
                    "icon": "fa-solid fa-vial"
                },
                {
                    "title": "المكونات أساسية",
                    "desc": "يحتوي العلاج على أحماض أمينية مثل الكارنيتين، وعوامل محفزة لتحلل الدهون، بالإضافة إلى فيتامين ب المركب والعناصر الغذائية الدقيقة.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "تحفيز حرق الدهون",
                    "desc": "تعمل هذه المواد معًا على تعزيز معدل الأيض، ما يساعد الجسم على حرق الدهون بشكل أفضل.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "زيادة مستوى الطاقة",
                    "desc": "تساعد هذه الجلسات على رفع مستويات الطاقة لديك إلى جانب دعم خسارة الوزن.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "جلسة سريعة",
                    "desc": "تستغرق الجلسة من 30 إلى 45 دقيقة في بيئة مريحة دون الحاجة لفترة نقاهة.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد العلاج",
            "subheading": "دعم شامل لرحلتك في خسارة الوزن",
            "para": "تُعتبر جلسة العلاج الوريدي لإنقاص الوزن مكملًا فعالًا لأي خطة لخسارة الوزن:",
            "items": [
                {
                    "title": "تسريع حرق الدهون",
                    "desc": "تساهم في تعزيز عملية التمثيل الغذائي للدهون وتفكيك التراكمات الدهنية في الكبد.",
                    "icon": "fa-solid fa-fire"
                },
                {
                    "title": "زيادة معدل الأيض",
                    "desc": "يساعد وجود عناصر مثل الكارنيتين الجسم على تسريع عملية حرق الدهون وبالتالي فقدان الوزن الزائد بشكل أسرع.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "تعزيز مستويات الطاقة",
                    "desc": "تحتوي الجلسة على فيتامينات أساسية تساعد على تقليل الشعور بالإرهاق والحفاظ على النشاط.",
                    "icon": "fa-solid fa-battery-full"
                },
                {
                    "title": "تعزيز الترطيب الداخلي",
                    "desc": "يساعد الترطيب الجيد على تحسين عملية الهضم، وتعزيز امتصاص العناصر الغذائية، والحفاظ على وظائف الجسم.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "إزالة السموم",
                    "desc": "تحتوي بعض الجلسات على مضادات أكسدة تدعم وظائف الكبد وتساعد الجسم في التخلص من السموم.",
                    "icon": "fa-solid fa-recycle"
                },
                {
                    "title": "آثار جانبية طفيفة",
                    "desc": "نظرًا لأن المكونات المستخدمة طبيعية، فإن الآثار الجانبية نادرة وخفيفة للغاية.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية للعلاج",
            "subheading": "",
            "para": "تُعتبر هذه الجلسة خياراً مثالياً للأشخاص الذين يحتاجون إلى دعم إضافي في رحلتهم لخسارة الوزن:",
            "items": [
                {
                    "title": "الأشخاص الذين يعانون من الدهون العنيدة",
                    "desc": "إذا كنت تلتزم بنظام غذائي وتمارين رياضية لكن النتائج غير مرضية، فقد تكون هذه الجلسة هي الحل.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "الأشخاص الذين يعانون من بطء عملية الأيض",
                    "desc": "المكونات المعززة لعملية الأيض تساعد الجسم على البدء بحرق الدهون المتراكمة بشكل أكثر كفاءة.",
                    "icon": "fa-solid fa-tachometer-alt"
                },
                {
                    "title": "رجال الأعمال المشغولين",
                    "desc": "الأشخاص الذين يعانون من الإرهاق المستمر بسبب جدولهم المزدحم ولا يملكون الطاقة الكافية لممارسة الرياضة.",
                    "icon": "fa-solid fa-briefcase"
                },
                {
                    "title": "المهتمون بالصحة",
                    "desc": "من يبحثون عن طريقة طبيعية وآمنة لتعزيز جهودهم في خسارة الوزن.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "قبل البدء في جلسات التنقيط الوريدي لإنقاص الوزن:",
            "items": [
                {
                    "title": "الاستشارة",
                    "desc": "ناقش أهدافك في خسارة الوزن، والتاريخ الطبي، والحالة الصحية الحالية مع طبيبنا المتخصص.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الفحوصات الطبية",
                    "desc": "قد يُطلب إجراء تحاليل طبية لتقييم صحتك العامة واكتشاف أي نقص في العناصر الغذائية.",
                    "icon": "fa-solid fa-microscope"
                },
                {
                    "title": "الترطيب",
                    "desc": "احرص على شرب كميات كافية من الماء قبل الجلسة لتحضير جسمك.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تجنب الوجبات الثقيلة",
                    "desc": "يُفضل تجنب تناول وجبة ثقيلة قبل الجلسة لتجنب الشعور بالانزعاج.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "الاسترخاء",
                    "desc": "تستغرق الجلسة عادةً من 30 إلى 45 دقيقة في منطقة جلوس مريحة.",
                    "icon": "fa-solid fa-couch"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "يُلاحظ العديد من المرضى النتائج التالية:",
            "items": [
                {
                    "title": "زيادة مستوى الطاقة",
                    "desc": "يشعر معظم الأشخاص من اليوم الأول بزيادة النشاط، ما يساعدهم على الحركة أكثر وحرق سعرات حرارية إضافية.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "دعم فقدان الوزن",
                    "desc": "مع الوقت، تعزز مكونات الجلسة قدرة الجسم على تفكيك الدهون العنيدة، مما يؤدي إلى خسارة فعالة في الوزن.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "تحسين الحالة المزاجية والصفاء الذهني",
                    "desc": "تساعد الفيتامينات والمعادن على دعم وظائف العقل، مما يمنحك صفاء ذهني ويقلل من التوتر.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "ترطيب أفضل وصحة عامة أقوى",
                    "desc": "يساهم الترطيب العميق في تحسين عملية الهضم ونضارة البشرة، وكفاءة وظائف الجسم الداخلية.",
                    "icon": "fa-solid fa-tint"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "لتعزيز والحفاظ على نتائجك:",
            "items": [
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "استمر في شرب كميات كافية من الماء لدعم عملية التمثيل الغذائي.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "نظام غذائي صحي",
                    "desc": "اتبع نظامًا غذائيًا متوازنًا لتعزيز تأثيرات العلاج.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "ممارسة الرياضة بانتظام",
                    "desc": "حافظ على نشاطك البدني لتعزيز حرق الدهون والحفاظ على النتائج.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "جلسات متابعة",
                    "desc": "فكر في الجلسات المنتظمة للحصول على فوائد مستدامة لخسارة الوزن.",
                    "icon": "fa-solid fa-calendar-alt"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تستغرق جلسة التنقيط الوريدي؟",
                    "answer": "تستغرق الجلسة عادةً من 30 إلى 45 دقيقة في بيئة مريحة."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "قد تشعر بوخز بسيط عند إدخال الإبرة، لكن العلاج نفسه غير مؤلم."
                },
                {
                    "question": "متى سألاحظ النتائج؟",
                    "answer": "يلاحظ العديد من المرضى زيادة في الطاقة فورًا، مع ظهور نتائج خسارة الوزن بعد عدة جلسات."
                },
                {
                    "question": "كم مرة يجب أن أحصل على هذا العلاج؟",
                    "answer": "يعتمد التكرار على الأهداف الفردية - يمكن لفريقنا الطبي تقديم توصية أثناء الاستشارة."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "الآثار الجانبية نادرة وقد تشمل كدمات طفيفة في موقع الحقن. المكونات طبيعية وآمنة."
                }
            ]
        }
    }
}